import { useEffect, useState, useRef } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fetches live prices + 24h changes via our backend proxy (GET /api/prices).
// The proxy caches CoinGecko responses server-side for 45s so we stay under
// their free-tier rate limits and avoid the CORS wall in the browser.
// Refreshes every 60s from the client. Falls back gracefully on error.
export const useCryptoPrices = (ids) => {
  const [data, setData] = useState({});
  const [status, setStatus] = useState('idle');
  const timerRef = useRef(null);

  useEffect(() => {
    if (!ids || ids.length === 0) return;
    const idsKey = ids.join(',');
    let cancelled = false;

    const fetchOnce = async () => {
      try {
        setStatus('loading');
        const res = await axios.get(`${API}/prices`, { params: { ids: idsKey }, timeout: 15000 });
        if (cancelled) return;
        const list = res.data?.data || [];
        const map = {};
        list.forEach((c) => { map[c.id] = c; });
        setData(map);
        setStatus('ready');
      } catch (e) {
        setStatus('error');
      }
    };

    fetchOnce();
    timerRef.current = setInterval(fetchOnce, 60000);
    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ids.join(',')]);

  return { data, status };
};
